module.exports = __webpack_public_path__ + "media/images/payment-providers/bank-transfer-card-d708db11fb5e8e3fd63727ace5511de3.svg";